import FormControlLabel from '@mui/material/FormControlLabel';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../stateManagement/hooks/redux';
import { Checkbox } from '@mui/material';
import { setItemWebStorage } from '../../features/webStorageSaver';
import { Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { setLastYearsMapFilters } from '../../stateManagement/reducers/MapFiltersSlice';
import ContentHeader from '../../widgets/contentHeader/ContentHeader';


// Создаем массив объектов с годами и соответствующими цветами
const currentYear = new Date().getFullYear();
const colorPalette = ['#cea11f', '#e15112', '#9820dd', '#1d4cc5', '#14c7c5', '#4b9305'];
export function getLastYearsWithColors(numberOfYears: any): any {
    return Array.from({ length: numberOfYears }, (_, index) => {
        const year = currentYear - index;
        const color = colorPalette[index];
        return { year, color };
    })
}

// Страница для отображения фильтров панорамы
export function LastYearsMapFilter({ filterType, numberOfYears, objectType }: any) {
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const lastYearsMapFilters = useAppSelector(state => state.mapFilters.lastYearsMapFilters)

    useEffect(() => {
        if (!lastYearsMapFilters?.[objectType]) {
            resetYearsMapFilter()
        }
    }, [objectType])

    function changeYearsMapFilter(event: any) {
        const { name, checked } = event.target;
        let newLastYearsMapFilters = { ...lastYearsMapFilters, [objectType]: { ...lastYearsMapFilters?.[objectType], [name]: checked } }
        dispatch(setLastYearsMapFilters(newLastYearsMapFilters))
        setItemWebStorage(`lastYearsMapFilters`, newLastYearsMapFilters)
    }

    function resetYearsMapFilter() {
        let newLastYearsMapFilters = { ...lastYearsMapFilters, [objectType]: { [currentYear]: true } }
        dispatch(setLastYearsMapFilters(newLastYearsMapFilters))
        setItemWebStorage(`lastYearsMapFilters`, newLastYearsMapFilters)
    }

    return (
        <>
            {filterType === 'page' &&
                <>
                    <ContentHeader title="Настройка фильтров" />
                    <div className="last-years-map-filter-page-div">
                        <div className="apply-filters-header mt-3 mb-2">
                            <span>ВЫБЕРИТЕ ГОДА ДИАГНОСТИКИ:</span>
                        </div>
                        <hr></hr>
                        <div className="checkboxes-div">
                            {getLastYearsWithColors(numberOfYears).map(({ year, color }: any) => (
                                <FormControlLabel
                                    className="checkbox-label"
                                    key={year}
                                    name={year}
                                    label={year}
                                    checked={!!lastYearsMapFilters?.[objectType]?.[year]}
                                    onChange={changeYearsMapFilter}
                                    color={color}
                                    control={<Checkbox className="ch-white" style={{ color }} />}
                                />
                            ))}
                        </div>
                        <hr></hr>
                        <div className="buttons-div">
                            <Button className="apply-filters-button" onClick={() => navigate(-1)}>Применить</Button>
                            <Button className="reset-filters-button" onClick={resetYearsMapFilter}>Сбросить</Button>
                        </div>
                    </div>
                </>
            }
            {filterType === 'header' &&
                <div className="last-years-map-filter-header-div">
                    <div className="checkboxes-div">
                        {getLastYearsWithColors(numberOfYears).map(({ year, color }: any) => (
                            <FormControlLabel
                                className="checkbox-label"
                                key={year}
                                name={year}
                                label={year}
                                checked={!!lastYearsMapFilters?.[objectType]?.[year]}
                                onChange={changeYearsMapFilter}
                                color={color}
                                control={<Checkbox className="ch-white" style={{ color }} />}
                            />
                        ))}
                    </div>
                </div>
            }
        </>
    );
}
